import { SchoolPartner } from '../../Types/SectionTemplates';

interface Props {
  schoolPartners: SchoolPartner[];
}

const SchoolPartnersTab: React.FC<Props> = ({ schoolPartners }) => (
  <div className="max-h-[57vh] overflow-y-auto px-11">
    {schoolPartners.map((partner, index) => (
      <div
        key={partner.id}
        className="border-b-1 border-solid border-border py-10 last:border-b-0"
        data-intercom-target={`school-partner-${index + 1}`}
      >
        <h3 className="text-xl font-medium text-foreground mb-4">{partner.name}</h3>
        {partner.logo_url
          .map((url) => (
            <img
              key="logo"
              src={url}
              alt={`${partner.name} logo`}
              className="max-h-16 max-w-[200px] object-contain"
            />
          ))
          .getOrElse(() => (
            <></>
          ))}
      </div>
    ))}
  </div>
);

export default SchoolPartnersTab;
